module.exports = __webpack_public_path__ + "img/28.2d72cc5e.png";